<my-header></my-header>
<div class="wrapper">
    <div class="heading--text">
        <span class="msg">Hi, {{dashbaordCounts?.patientName}}</span>
        <ng-container *ngIf="isPatientDOB">
            <img alt="Happy Birthday" class="hb-icon" alt="Happy Birthday!" src="/assets/images/hb.png"/>
        </ng-container>
    </div> 
    <app-banner></app-banner>
    <main class="main-content">
         <div class="box box--1" (click)="showSection('newPrescription')">
            <div class="left-box"><img alt="New eRx(s)"  src="/assets/images/New-Prescription.png"/></div>
            <div class="middle-box">New eRx(s)</div>
            <div class="right-box">{{dashbaordCounts?.New_Prescription}}</div>
        </div>
           <div class="box box--2" (click)="showSection('refillsDue')">
            <div class="left-box"><img alt="Refills Due"  src="/assets/images/RefillsDue.png"/></div>
            <div class="middle-box">Refills Due</div>
            <div class="right-box">{{dashbaordCounts?.Refills_Due}}</div>
        </div>
           <div class="box box--3" (click)="showSection('myMeds')">
            <div class="left-box"><img alt="My Meds"  src="/assets/images/MyMeds.png"/></div>
            <div class="middle-box">My Meds</div>
            <div class="right-box">{{dashbaordCounts?.My_Meds}}</div>
        </div>
        <div class="box box--5" (click)="showSection('pendingPayments')">
            <div class="left-box"><img alt="Pending Payments"  src="/assets/images/PendingPayments.png"/></div>
            <div class="middle-box">Pending Orders</div>
            <div class="right-box">{{dashbaordCounts?.Pending_Payments}}</div>
        </div>
        <div class="box box--4" (click)="showSection('readyToDispense')">
            <div class="left-box"><img alt="Rx(s) Ready"  src="/assets/images/Ready-to-Dispense.png"/></div>
            <div class="middle-box">Rx(s) Ready</div>
            <div class="right-box">{{dashbaordCounts?.Ready_to_Dispense}}</div>
        </div>
     
       
        <div class="box box--6">
            <span class="box--bg">We're here to <br/>support you on<br/> your health<br/> journey.</span>
            <img alt="Pharmacy" class="bannerGirl-bg" src="/assets/images/bannerGirl.png"/>
        </div>
    </main>
</div>
<my-footer></my-footer>